import script from "./ImageBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageBlock.vue?vue&type=script&setup=true&lang=js"

import "./ImageBlock.vue?vue&type=style&index=0&id=4d2719e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2719e8"]])

export default __exports__